import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevanseatertempotarvelleronrentinshirdi() {



    const cardData = {




keyword: "17 Seater Tempo Traveller On Rent in Shirdi",
headingDescription: "Sai Shirdi Cab provides a comfortable 17 Seater Tempo Traveller on rent in Shirdi for families, friends, pilgrimage groups, corporate teams, wedding parties, school and college groups, and other larger travel groups. Our 17 Seater Tempo Traveller rental service is suitable for local sightseeing, airport transfers, religious tours, corporate travel, wedding transportation, one-way journeys, round trips, and multi-day outstation trips. With a dedicated 17 seater vehicle, the complete group can travel together with convenient seating and sufficient space for luggage and travel essentials. Customers can customize their journey according to the pickup location, travel date, destination, passenger requirement, trip duration, and planned itinerary. Whether you are arranging a short group trip from Shirdi or a long-distance tour across Maharashtra and nearby states, Sai Shirdi Cab offers a practical and convenient solution for organized group transportation.",
topPlaces: [
{
title: "Goa",
description: "Take a 17 Seater Tempo Traveller from Shirdi to Goa for a comfortable holiday with family, friends, or a group of travellers. Sai Shirdi Cab provides dedicated group transportation for long-distance journeys, helping everyone stay together while carrying luggage and enjoying a more organized travel experience."
},
{
title: "Pune",
description: "A 17 Seater Tempo Traveller on rent in Shirdi is an excellent option for groups travelling to Pune for corporate visits, family functions, educational trips, events, or sightseeing. The dedicated vehicle allows the entire group to travel together while making pickup, route planning, and return arrangements easier to coordinate."
},
{
title: "Mumbai",
description: "Hire a 17 seater Tempo Traveller from Shirdi to Mumbai for airport transfers, business travel, family occasions, group events, or sightseeing. Sai Shirdi Cab offers a convenient way for larger groups to share one vehicle, reducing the need for multiple cars and making luggage and passenger coordination simpler."
},
{
title: "Mahabaleshwar",
description: "Plan a group holiday from Shirdi to Mahabaleshwar with a 17 Seater Tempo Traveller for comfortable sightseeing and weekend travel. Families and friends can travel together with their luggage while customizing the journey around their preferred pickup point, sightseeing schedule, stay duration, and return plan."
},
{
title: "Nashik",
description: "Travel from Shirdi to Nashik in a 17 Seater Tempo Traveller for family tours, religious visits, corporate requirements, and group sightseeing. Sai Shirdi Cab can arrange a dedicated vehicle according to your travel schedule, making it convenient to include planned stops and coordinate the complete group journey."
},
{
title: "Ujjain",
description: "Book a 17 Seater Tempo Traveller from Shirdi to Ujjain for a group pilgrimage or multi-day religious journey. The vehicle is suitable for devotees, families, and organized travel groups who prefer travelling together, with flexible arrangements for pickup, route planning, luggage, stops, and return travel."
},
{
title: "Bhimashankar",
description: "A 17 Seater Tempo Traveller is a convenient choice for groups travelling from Shirdi to Bhimashankar for pilgrimage and sightseeing. Sai Shirdi Cab provides dedicated group transportation so families and devotees can remain together throughout the journey while comfortably managing their travel belongings."
},
{
title: "Chhatrapati Sambhajinagar",
description: "Hire a 17 Seater Tempo Traveller in Shirdi for a group trip to Chhatrapati Sambhajinagar, whether the purpose is sightseeing, pilgrimage, business, or a family tour. With one vehicle for the complete group, passengers can coordinate their schedule more easily and plan additional stops according to their itinerary."
},
{
title: "Trimbakeshwar",
description: "Travel from Shirdi to Trimbakeshwar with a 17 Seater Tempo Traveller for a convenient pilgrimage or group sightseeing tour. This option works well for families, devotees, and friends travelling together, with flexible trip planning based on the preferred pickup point, travel date, route, and return schedule."
},
{
title: "Ahmednagar",
description: "Choose a 17 Seater Tempo Traveller on rent in Shirdi for group travel to Ahmednagar for family events, business visits, religious programs, or sightseeing. Sai Shirdi Cab helps groups arrange dedicated transportation around their passenger requirement and itinerary, providing a more coordinated alternative to using multiple smaller vehicles."
}
]
,







"services": [
{
"name": "17 Seater Tempo Traveller On Rent in Shirdi",
"description": "17 Seater Tempo Traveller On Rent in Shirdi from Sai Shirdi Cabs is a comfortable group travel option for families, tourists, pilgrims, and larger travel parties. The spacious vehicle is suitable for local sightseeing, outstation journeys, family vacations, and multi-day tours with professional driver support."
},
{
"name": "17 Seater Tempo Traveller Rental Shirdi",
"description": "17 Seater Tempo Traveller Rental Shirdi provides convenient transportation for groups who want to travel together in one spacious vehicle. Sai Shirdi Cabs offers rental services for pilgrimage trips, family tours, corporate outings, weddings, sightseeing programs, and long-distance road journeys."
},
{
"name": "17 Seater Tempo Traveller Hire Shirdi",
"description": "17 Seater Tempo Traveller Hire Shirdi is ideal for groups requiring comfortable and reliable transportation for different travel requirements. Sai Shirdi Cabs provides well-maintained vehicles with experienced drivers for local transfers, sightseeing, religious tours, family trips, and outstation travel."
},
{
"name": "17 Seater Tempo Traveller Booking Shirdi",
"description": "17 Seater Tempo Traveller Booking Shirdi makes group travel planning simple for customers visiting Shirdi or traveling to other destinations. Sai Shirdi Cabs offers flexible booking arrangements for family holidays, pilgrimage tours, corporate travel, wedding functions, sightseeing, and customized outstation itineraries."
},
{
"name": "17 Seater Tempo Traveller with Driver Shirdi",
"description": "17 Seater Tempo Traveller with Driver Shirdi provides a relaxed travel experience for groups who prefer professional driving assistance. Sai Shirdi Cabs offers experienced drivers along with spacious vehicles for temple visits, family trips, corporate journeys, sightseeing tours, and longer road travel."
},
{
"name": "17 Seater Traveller on Rent Shirdi",
"description": "17 Seater Traveller on Rent Shirdi is a practical solution for families and groups looking for spacious transportation in and around Shirdi. Sai Shirdi Cabs provides comfortable vehicles for pilgrimage journeys, tourist trips, airport transfers, family outings, and outstation travel with convenient pickup and drop arrangements."
},
{
"name": "17 Seater Tourist Vehicle Shirdi",
"description": "17 Seater Tourist Vehicle Shirdi offers convenient group transportation for travelers exploring Shirdi and nearby destinations. Sai Shirdi Cabs provides spacious tourist vehicles suitable for sightseeing, pilgrimage tours, family vacations, weekend trips, and multi-city travel plans with professional driver support."
},
{
"name": "17 Seater Tempo Traveller Cab Shirdi",
"description": "17 Seater Tempo Traveller Cab Shirdi is suitable for larger groups who need more space than a standard cab can provide. Sai Shirdi Cabs offers comfortable group transportation for local travel, temple visits, sightseeing, family functions, airport transfers, and outstation journeys from Shirdi."
},
{
"name": "17 Seater Tempo Traveller Taxi Shirdi",
"description": "17 Seater Tempo Traveller Taxi Shirdi provides spacious and convenient transportation for families, tourists, corporate teams, and pilgrimage groups. With Sai Shirdi Cabs, travelers can arrange driver-assisted journeys for local sightseeing, airport transfers, religious tours, special occasions, and long-distance routes."
},
{
"name": "17 Seater Tempo Traveller for Outstation Shirdi",
"description": "17 Seater Tempo Traveller for Outstation Shirdi is a comfortable option for groups traveling from Shirdi to cities, tourist destinations, pilgrimage centers, and airports. Sai Shirdi Cabs provides spacious vehicles and professional drivers to make longer journeys more convenient while keeping the entire group together."
},
{
"name": "17 Seater Tempo Traveller for Family Trip Shirdi",
"description": "17 Seater Tempo Traveller for Family Trip Shirdi allows families to travel together comfortably without arranging several smaller vehicles. Sai Shirdi Cabs provides spacious transportation for vacations, weekend getaways, family functions, temple visits, sightseeing tours, and multi-destination road trips."
},
{
"name": "17 Seater Tempo Traveller for Wedding Shirdi",
"description": "17 Seater Tempo Traveller for Wedding Shirdi is a convenient transportation option for wedding guests, relatives, and event groups. Sai Shirdi Cabs can arrange comfortable vehicles for hotel transfers, venue transportation, airport pickups, railway station transfers, and wedding-related outstation journeys."
},
{
"name": "17 Seater Tempo Traveller for Corporate Trip Shirdi",
"description": "17 Seater Tempo Traveller for Corporate Trip Shirdi provides comfortable group transportation for employees, business teams, meetings, conferences, and company outings. Sai Shirdi Cabs offers professional driver-assisted travel for corporate groups requiring dependable local or outstation transportation."
},
{
"name": "17 Seater Tempo Traveller for Pilgrimage Shirdi",
"description": "17 Seater Tempo Traveller for Pilgrimage Shirdi is designed for families and religious groups visiting temples and spiritual destinations. Sai Shirdi Cabs provides spacious group transportation for Shirdi darshan, multi-temple tours, religious circuits, and longer pilgrimage journeys with convenient travel arrangements."
},
{
"name": "17 Seater Tempo Traveller for Tour Shirdi",
"description": "17 Seater Tempo Traveller for Tour Shirdi is an excellent choice for groups planning sightseeing holidays and multi-destination road trips. Sai Shirdi Cabs offers comfortable vehicles for exploring tourist attractions, pilgrimage locations, hill stations, cultural destinations, and popular places around Maharashtra."
},
{
"name": "17 Seater Tempo Traveller One Way Shirdi",
"description": "17 Seater Tempo Traveller One Way Shirdi is convenient for groups traveling from Shirdi to another destination without requiring the vehicle for the return journey. Sai Shirdi Cabs provides one-way transportation for airport transfers, business travel, family trips, pilgrimage routes, and outstation journeys."
},
{
"name": "17 Seater Tempo Traveller Round Trip Shirdi",
"description": "17 Seater Tempo Traveller Round Trip Shirdi is suitable for return journeys, family vacations, pilgrimage tours, sightseeing programs, and multi-day trips. Sai Shirdi Cabs provides spacious vehicles with driver support so groups can follow their planned itinerary comfortably and return to Shirdi after completing their journey."
},
{
"name": "17 Seater Tempo Traveller Airport Pickup Shirdi",
"description": "17 Seater Tempo Traveller Airport Pickup Shirdi provides spacious transportation for groups arriving at nearby airports and traveling onward to Shirdi. Sai Shirdi Cabs offers comfortable vehicles with sufficient passenger and luggage space, making airport-to-Shirdi transfers convenient for families and larger groups."
},
{
"name": "17 Seater Tempo Traveller Railway Station Shirdi",
"description": "17 Seater Tempo Traveller Railway Station Shirdi is a convenient option for groups arriving at or departing from railway stations serving Shirdi. Sai Shirdi Cabs can arrange spacious transportation for pilgrimage groups, family pickups, hotel transfers, sightseeing travelers, and onward outstation journeys."
},
{
"name": "Affordable 17 Seater Tempo Traveller Shirdi",
"description": "Affordable 17 Seater Tempo Traveller Shirdi from Sai Shirdi Cabs provides a budget-conscious group travel option with spacious seating and convenient driver support. It is suitable for pilgrimage tours, family vacations, sightseeing trips, corporate outings, weddings, airport transfers, and outstation journeys."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides reliable 17 Seater Tempo Traveller rental, hire, booking, airport pickup, railway station transfers, sightseeing, pilgrimage, family, corporate, wedding, and outstation transportation services in Shirdi. Our spacious vehicles and professional drivers are suitable for comfortable group travel across a wide range of routes."
}
],
"tableData": [
["17 Seater Tempo Traveller On Rent in Shirdi", "17 Seater Tempo Traveller Rental Shirdi"],
["17 Seater Tempo Traveller Hire Shirdi", "17 Seater Tempo Traveller Booking Shirdi"],
["17 Seater Tempo Traveller with Driver Shirdi", "17 Seater Traveller on Rent Shirdi"],
["17 Seater Tourist Vehicle Shirdi", "17 Seater Tempo Traveller Cab Shirdi"],
["17 Seater Tempo Traveller Taxi Shirdi", "17 Seater Tempo Traveller for Outstation Shirdi"],
["17 Seater Tempo Traveller for Family Trip Shirdi", "17 Seater Tempo Traveller for Wedding Shirdi"],
["17 Seater Tempo Traveller for Corporate Trip Shirdi", "17 Seater Tempo Traveller for Pilgrimage Shirdi"],
["17 Seater Tempo Traveller for Tour Shirdi", "17 Seater Tempo Traveller One Way Shirdi"],
["17 Seater Tempo Traveller Round Trip Shirdi", "17 Seater Tempo Traveller Airport Pickup Shirdi"],
["17 Seater Tempo Traveller Railway Station Shirdi", "Affordable 17 Seater Tempo Traveller Shirdi"],
["Sai Shirdi Cabs", "17 Seater Tempo Traveller On Rent in Shirdi"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "17 Seater Tempo Traveller on Rent in Shirdi",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides a 17 Seater Tempo Traveller on Rent in Shirdi for families, pilgrimage groups, tourists, corporate teams, school groups, and other passengers travelling together. The vehicle can be arranged for Shirdi sightseeing, temple visits, airport and railway station transfers, family functions, outstation trips, and multi-day road journeys according to your planned travel schedule."   
 
    },   
 
    {   
 
        WhyChooseheading: "Comfortable 17 Seater Tempo Traveller Rental",   
 
        WhyChoosedescription: "Groups looking for convenient shared transportation can rent a 17 Seater Tempo Traveller in Shirdi for planned journeys. Sai Shirdi Cabs can organize the vehicle according to your passenger count, luggage requirements, pickup location, destination, travel date, departure timing, and journey duration to make group travel easier to coordinate."   
 
    },   
 
    {   
 
        WhyChooseheading: "17 Seater Tempo Traveller for Shirdi Sightseeing",   
 
        WhyChoosedescription: "Tourists and families can hire a 17 Seater Tempo Traveller for exploring Shirdi and nearby attractions together. The trip can be planned around your selected sightseeing locations, temple visits, hotel transfers, meal stops, pickup points, and preferred timings, allowing the entire group to travel on a coordinated itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "Tempo Traveller for Shirdi Pilgrimage Tours",   
 
        WhyChoosedescription: "Devotee groups can arrange a 17 Seater Tempo Traveller in Shirdi for pilgrimage journeys, temple visits, Darshan travel, and religious tours to nearby destinations. Sai Shirdi Cabs can plan transportation based on your pilgrimage schedule, passenger requirements, luggage, pickup point, planned stops, and overall route."   
 
    },   
 
    {   
 
        WhyChooseheading: "17 Seater Traveller for Outstation Trips",   
 
        WhyChoosedescription: "Groups travelling from Shirdi to other cities, tourist destinations, and religious locations can hire a 17 Seater Tempo Traveller for outstation journeys. One-way, round-trip, and multi-day travel arrangements can be discussed according to your destination, travel dates, route, passenger count, luggage requirements, and sightseeing plans."   
 
    },   
 
    {   
 
        WhyChooseheading: "Tempo Traveller for Family and Group Tours",   
 
        WhyChoosedescription: "A 17 Seater Tempo Traveller is suitable for family vacations, friends' trips, corporate outings, school and college groups, social gatherings, and organized tours from Shirdi. Travelling together helps simplify coordination for luggage, departure timings, sightseeing stops, hotel transfers, meal breaks, and other planned activities during the journey."   
 
    },   
 
    {   
 
        WhyChooseheading: "17 Seater Traveller for Airport and Railway Transfers",   
 
        WhyChoosedescription: "Large groups arriving in or departing from Shirdi can arrange a 17 Seater Tempo Traveller for airport and railway station transfers. Sai Shirdi Cabs can coordinate the transfer according to your arrival or departure schedule, pickup location, passenger count, luggage requirements, destination, and onward travel plans."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book 17 Seater Tempo Traveller on Rent in Shirdi",   
 
        WhyChoosedescription: "To book a 17 Seater Tempo Traveller on Rent in Shirdi, contact Sai Shirdi Cabs with your travel date, pickup location, passenger count, destination, luggage details, preferred departure time, journey type, and rental duration. Providing complete trip information helps in arranging suitable transportation for pilgrimage tours, sightseeing, family travel, events, airport transfers, and outstation journeys."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I rent a 17 Seater Tempo Traveller in Shirdi?", 
 
answer: "Yes, Sai Shirdi Cabs provides 17 Seater Tempo Traveller rental services in Shirdi for families, tourists, pilgrimage groups, corporate teams, school groups, and other group travel requirements." 
 
}, 
 
{ 
 
question: "What can I use a 17 Seater Tempo Traveller in Shirdi for?", 
 
answer: "The 17 Seater Tempo Traveller can be arranged for Shirdi sightseeing, pilgrimage tours, family trips, corporate travel, airport transfers, railway station transfers, events, and outstation journeys." 
 
}, 
 
{ 
 
question: "Can I hire a 17 Seater Tempo Traveller for Shirdi sightseeing?", 
 
answer: "Yes, you can hire a 17 Seater Tempo Traveller for Shirdi sightseeing and nearby attractions according to your selected locations, passenger count, pickup point, travel schedule, and sightseeing requirements." 
 
}, 
 
{ 
 
question: "Is a 17 Seater Tempo Traveller suitable for pilgrimage groups?", 
 
answer: "Yes, the 17 Seater Tempo Traveller can be arranged for pilgrimage groups travelling from Shirdi to temples, religious destinations, and other spiritual locations according to the group's planned itinerary." 
 
}, 
 
{ 
 
question: "Can I book a 17 Seater Tempo Traveller from Shirdi for an outstation trip?", 
 
answer: "Yes, you can arrange a 17 Seater Tempo Traveller from Shirdi for selected outstation destinations through one-way, round-trip, or multi-day travel arrangements based on your journey requirements." 
 
}, 
 
{ 
 
question: "Can families hire a 17 Seater Tempo Traveller in Shirdi?", 
 
answer: "Yes, families can hire a 17 Seater Tempo Traveller for vacations, sightseeing, pilgrimage travel, family functions, airport transfers, railway transfers, and long-distance road trips." 
 
}, 
 
{ 
 
question: "Can corporate groups rent a 17 Seater Tempo Traveller in Shirdi?", 
 
answer: "Yes, corporate teams can arrange a 17 Seater Tempo Traveller for business visits, meetings, events, employee travel, group outings, airport transfers, and other planned transportation requirements." 
 
}, 
 
{ 
 
question: "Can luggage be carried in a 17 Seater Tempo Traveller?", 
 
answer: "Yes, passengers can travel with luggage, and sharing the approximate luggage quantity along with the passenger count helps in planning a suitable vehicle arrangement for the journey." 
 
}, 
 
{ 
 
question: "Can I rent the 17 Seater Tempo Traveller for multiple days?", 
 
answer: "Yes, multi-day rental can be discussed for pilgrimage tours, family vacations, sightseeing trips, group events, and multi-destination road journeys according to your planned itinerary." 
 
}, 
 
{ 
 
question: "How can I book a 17 Seater Tempo Traveller on Rent in Shirdi?", 
 
answer: "You can contact Sai Shirdi Cabs with your travel date, pickup location, passenger count, destination, luggage details, preferred departure time, journey type, and rental duration to arrange a 17 Seater Tempo Traveller." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Sandeep Patil", 
 
feedback: "Our pilgrimage group needed a vehicle that could keep everyone together throughout the Shirdi trip and the following temple visits. The 17 Seater Tempo Traveller made it easier to manage our luggage, Darshan schedule, meal breaks, and planned stops without arranging separate cars.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Kavita Joshi", 
 
feedback: "For our family road trip, the 17 Seater Tempo Traveller was a practical choice for travelling as one group. We could follow our sightseeing plan comfortably, coordinate hotel transfers and stops, and avoid the inconvenience of managing several vehicles during the journey.", 
 
rating: 5 
 
} 
 
];

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Tempo Traveller On Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/17-seater-tempo-traveller-on-rent-in-shirdi.webp",
  "description":
    "Book a 17 Seater Tempo Traveller on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group travel. Our 17 Seater Tempo Traveller is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimage journeys, weddings, corporate travel, airport transfers, railway station transfers, one-way journeys, round trips, and outstation travel. Get a well-maintained vehicle with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/17-seater-tempo-traveller-on-rent-in-shirdi"
  }
};






    return (
        <div>

<Helmet>
  <title>17 Seater Tempo Traveller On Rent in Shirdi | Rental & Hire | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 17 Seater Tempo Traveller on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, family trips, weddings, corporate travel and outstation journeys. Get a spacious vehicle with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="17 Seater Tempo Traveller On Rent in Shirdi, 17 Seater Tempo Traveller Rental Shirdi, 17 Seater Tempo Traveller Hire Shirdi, 17 Seater Tempo Traveller Booking Shirdi, 17 Seater Tempo Traveller with Driver Shirdi, 17 Seater Tempo Traveller for Outstation Shirdi, 17 Seater Tempo Traveller for Family Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/124.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onesevanseatertempotarvelleronrentinshirdi;